/**
 * Que la página de fondo no se mueva mientras hay algo encima: una ventana, el
 * menú del celular, la hoja de un producto del catálogo web.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 *  ⚠️ LA PÁGINA QUE NO BAJABA CON LA RUEDA DEL MOUSE (2026-10-07)
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * Lo reportaron dos clientes: «a veces bajan con el mouse y no baja». No era
 * el mouse.
 *
 * Cada ventana bloqueaba el fondo por su cuenta: guardaba cómo estaba la
 * página al abrirse y lo devolvía al cerrarse. Con UNA sola, perfecto. Con dos
 * a la vez —una se abre encima y la de abajo se cierra primero— la segunda
 * había guardado «bloqueada» (porque la primera seguía abierta) y eso devolvía
 * al cerrarse: la página quedaba sin desplazarse hasta recargar, sin ninguna
 * ventana a la vista.
 *
 * Ahora se cuentan: la primera que se abre bloquea, y la ÚLTIMA que se cierra
 * suelta. El orden en que se cierren ya no importa.
 *
 *     useEffect(() => {
 *       if (!abierto) return;
 *       return bloquearDesplazamiento();
 *     }, [abierto]);
 */

let abiertos = 0;
let comoEstaba = "";

/** Bloquea el desplazamiento de la página. Devuelve con qué soltarlo. */
export function bloquearDesplazamiento(): () => void {
  if (abiertos === 0) {
    comoEstaba = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  abiertos += 1;

  let suelto = false;
  return () => {
    // Soltar dos veces el mismo no puede soltar el de otro.
    if (suelto) return;
    suelto = true;
    abiertos -= 1;
    if (abiertos === 0) document.body.style.overflow = comoEstaba;
  };
}
